<template>
<div class="chapter">
<div class="inner_page">
<div class="halfTitlePage" id="halfTitlePage_01"><p class="halfTitlePageTitle"><span>SOLOMON TIME</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416593218_halfTitlePage_01.vue?58b38ee2